import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from "./shared/shared.module";
import { MatTabsModule } from '@angular/material/tabs';
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { SessionService } from './core/session/session.service';
import { MatDialog } from '@angular/material/dialog';
import { SessionExpiredModalComponent } from './core/session/components/session-expired-modal/session-expired-modal.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    SharedModule,
    MatTabsModule,
    HttpClientModule,
    TranslateModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly sessionService = inject(SessionService);
  private readonly matDialog = inject(MatDialog);

  constructor() {
    this.sessionService.sessionWarning$.subscribe(() => {
      this.matDialog.open(SessionExpiredModalComponent, {
        width: '452px',
        disableClose: true
      });
    });

    this.sessionService.restoreSessionTimers();
  }
}

